import { Compass, Vote, Sparkles, User } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const TABS = [
  { id: 'home', path: '/citizen/home', label: 'Home', icon: Compass },
  { id: 'ballot', path: '/citizen/ballot', label: 'Ballot', icon: Vote },
  { id: 'chat', path: '/citizen/chat', label: 'Chat', icon: Sparkles },
  { id: 'profile', path: '/citizen/profile', label: 'You', icon: User },
];

// Paths where the bottom tab bar is visible
export const TAB_PATHS = TABS.map((t) => t.path);

export function TabBar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      aria-label="Primary"
      className="tab-bar-safe fixed bottom-0 left-0 right-0 z-40 border-t"
      style={{
        background: 'color-mix(in oklab, var(--background) 94%, transparent)',
        borderColor: 'var(--border)',
        backdropFilter: 'blur(20px)',
      }}
    >
      <div className="flex max-w-md mx-auto">
        {TABS.map((t) => {
          const active = location.pathname === t.path;
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => navigate(t.path)}
              className="flex-1 flex flex-col items-center justify-center gap-1 py-2.5 hover-elevate active-elevate-2 transition-colors"
            >
              <div className="relative">
                <Icon className="w-5 h-5" style={{ color: active ? 'var(--primary)' : 'var(--muted-foreground)' }} />
                {active && (
                  <span
                    className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full"
                    style={{ background: 'var(--primary)' }}
                  />
                )}
              </div>
              <span
                className="text-[10px] font-bold tracking-wide uppercase"
                style={{ color: active ? 'var(--primary)' : 'var(--muted-foreground)' }}
              >
                {t.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
